var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrench1Copy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_926_4479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7458 4.14505C19.68 3.93661 19.51 3.77838 19.2975 3.72665C19.0858 3.67493 18.8617 3.73749 18.7074 3.8916L16.0675 6.53076L14.0466 5.95245L13.4683 3.93173L16.1084 1.29166C16.2633 1.13754 16.3251 0.913391 16.2733 0.701599C16.2216 0.489197 16.0634 0.319977 15.8549 0.253296C15.3217 0.085907 14.7542 0 14.1667 0C10.95 0 8.33328 2.61673 8.33328 5.83328C8.33328 6.51413 8.44757 7.17163 8.6734 7.79327L0.733337 15.7333C0.26001 16.2059 0 16.8333 0 17.5C0 18.1667 0.26001 18.7941 0.733337 19.2667C1.2059 19.74 1.83334 20 2.5 20C3.16666 20 3.7941 19.74 4.26666 19.2667L12.2067 11.3266C12.8284 11.5524 13.4859 11.6667 14.1667 11.6667C17.3833 11.6667 20 9.04999 20 5.83328C20 5.24582 19.9141 4.67834 19.7458 4.14505Z",
    fill: "#D42124"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_926_4479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench1Copy);
export default __webpack_public_path__ + "static/media/wrench1 copy.2b514517c36b289ce77478a6507adb71.svg";
export { ForwardRef as ReactComponent };